export const generateTemplateSchema = (template) => {
  const schema = {
    form_fields: [],
    media_field: null,
    variable_order: [],
    payload_mapping: {},
    carousel_media: [],
  };

  if (!template) {
    return schema;
  }

  const inferLabel = (_text, varNum) => {
    return `Value ${varNum}`;
  };

  const addTextVariables = (text, varIdPrefix, mapping) => {
    if (!text) return;
    const regex = /\{\{(\d+)\}\}/g;
    let match;
    while ((match = regex.exec(text)) !== null) {
      const varNum = match[1];
      const varId = `${varIdPrefix}${varNum}`;
      if (!schema.form_fields.some((f) => f.id === varId)) {
        schema.form_fields.push({
          id: varId,
          type: 'text',
          label: inferLabel(text, varNum),
          required: true,
        });
        schema.variable_order.push(varId);
        schema.payload_mapping[varId] = mapping(varNum);
      }
    }
  };

  const hasComponents =
    template.components && Array.isArray(template.components);

  if (hasComponents) {
    const header = template.components.find(
      (c) => (c.type || '').toUpperCase() === 'HEADER',
    );
    if (header) {
      const format = (header.format || 'TEXT').toUpperCase();
      if (['DOCUMENT', 'IMAGE', 'VIDEO'].includes(format)) {
        schema.media_field = {
          type: format.toLowerCase(),
          required: true,
          label: `Upload ${format.toLowerCase()}`,
        };
      } else if (format === 'TEXT' && header.text) {
        addTextVariables(header.text, 'header_var_', (varNum) => ({
          component: 'HEADER',
          index: varNum,
        }));
      }
    }

    const body = template.components.find(
      (c) => (c.type || '').toUpperCase() === 'BODY',
    );
    if (body && body.text) {
      addTextVariables(body.text, 'body_var_', (varNum) => ({
        component: 'BODY',
        index: varNum,
      }));
    }

    const buttons = template.components.find(
      (c) => (c.type || '').toUpperCase() === 'BUTTONS',
    );
    if (buttons && Array.isArray(buttons.buttons)) {
      buttons.buttons.forEach((btn, btnIndex) => {
        if (btn.type === 'URL' && btn.url) {
          addTextVariables(btn.url, `button_${btnIndex}_var_`, (varNum) => ({
            component: 'BUTTONS',
            buttonIndex: btnIndex,
            index: varNum,
          }));
        }
      });
    }
  }

  // Fallback: check top-level header_type or header_format if media_field not yet detected
  if (!schema.media_field) {
    const format = (
      template.header_type ||
      template.header_format ||
      template.header?.format ||
      template.header?.type ||
      ''
    ).toUpperCase();
    if (['DOCUMENT', 'IMAGE', 'VIDEO'].includes(format)) {
      schema.media_field = {
        type: format.toLowerCase(),
        required: true,
        label: `Upload ${format.toLowerCase()}`,
      };
    }
  }

  const carouselCards =
    (Array.isArray(template.cards) && template.cards) ||
    template.components?.find(
      (c) => (c.type || '').toUpperCase() === 'CAROUSEL',
    )?.cards ||
    [];

  if (template.body_text && !hasComponents) {
    addTextVariables(template.body_text, 'body_var_', (varNum) => ({
      component: 'BODY',
      index: varNum,
    }));
  }

  carouselCards.forEach((card, cardIndex) => {
    const cardBody =
      card.body_text ||
      card.components?.find((c) => (c.type || '').toUpperCase() === 'BODY')
        ?.text ||
      '';
    addTextVariables(cardBody, `card_${cardIndex}_body_var_`, (varNum) => ({
      component: 'CAROUSEL',
      cardIndex,
      index: varNum,
    }));

    const cardButtons =
      card.buttons ||
      card.components?.find((c) => (c.type || '').toUpperCase() === 'BUTTONS')
        ?.buttons ||
      [];
    cardButtons.forEach((btn, btnIndex) => {
      const url = btn.url || btn.value || '';
      const isUrl = btn.type === 'URL' || btn.type === 'url';
      if (isUrl && url) {
        addTextVariables(
          url,
          `card_${cardIndex}_button_${btnIndex}_var_`,
          (varNum) => ({
            component: 'CAROUSEL',
            cardIndex,
            buttonIndex: btnIndex,
            index: varNum,
          }),
        );
      }
    });

    const cardHeader = card.components?.find(
      (c) => (c.type || '').toUpperCase() === 'HEADER',
    );
    const cardFormat = (
      cardHeader?.format ||
      card.header_type ||
      card.header_format ||
      ''
    ).toUpperCase();
    if (['DOCUMENT', 'IMAGE', 'VIDEO'].includes(cardFormat)) {
      schema.carousel_media.push({
        cardIndex,
        type: cardFormat.toLowerCase(),
        required: true,
        label: `Card ${cardIndex + 1} Image/Video`,
      });
    }
  });

  return schema;
};
